export class StakeholderReferenceDto {

    public id: string;
    public Name: string;
    public Desc?: string;
    public Address?: string;
    public Location?: string;
    public CountryId?: string;
    public SubscriberId?: string;
    public SiteId?: string;
    public SectorId?: string;
    public StakeholderGroupId?: string;

    public Type: string;
}